import React, { useState, useEffect, useRef } from "react";
import {
  Col,
  Container,
  Row,
  Table,
  Button,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ThreeDotSpinner } from "../loader";
import PhoneInput from 'react-phone-input-2';
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import { apiService } from "../../service/api.service";
import moment from "moment";
import { apiUrl, baseUrl, dateFormate, formatBalance, formatWithDecimals } from "../../config/config";
import "bootstrap/dist/css/bootstrap.min.css";
import Countdown from "react-countdown";
import Select from "react-select";
import 'react-phone-input-2/lib/style.css';
import AirdropNotifyRowAction from "./AirdropNotifyRowAction";
export const UsersList = () => {
  const userTypeOptions = [
    { value: "All", label: "All" },
    { value: "CUSTODIAL", label: "Custodial" },
    { value: "NON-CUSTODIAL", label: "Non Custodial" },

  ];

  const solanaOptions = [
    { value: false, label: "All" },
    { value: true, label: "Solana" }

  ];
  const [selectUserType, setSelectUserType] = useState(userTypeOptions[0]);
  const [selectIsSolana, setSelectIsSolana] = useState(solanaOptions[0].value);

  const [userData, setUserData] = useState([]);
  const [totalItems, setTotalItems] = useState();
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [type, setType] = useState("");
  const [deactivatedReason, setDeactivatedReason] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPhoneEditModal, setShowPhoneEditModal] = useState(false);
  const [calldata, setcallData] = useState();
  const [limit, setlimit] = useState(10);
  const [show, setShow] = useState(false);
  const [editedPoint, setEditedPoint] = useState("");
  const [editedPhone, setEditedPhone] = useState("");
  const [error, setError] = useState("");
  const [wallet_address, setWallet] = useState("");
  const [userId, setUserId] = useState("");
  const [updateType, setupdateType] = useState("");
  const optionsUpdateType = [
    { value: "", label: "Select Update Type" },
    { value: "add", label: "Add" },
    { value: "subtract", label: "Subtract" },

  ];
  const [showProfileAnswersModal, setShowProfileAnswersModal] = useState(false);
  const [selectedProfileAnswers, setSelectedProfileAnswers] = useState([]);


  const styles = {
    otpInput: {
      width: '3rem',
      height: '3rem',
      margin: '0 6px',
      fontSize: '18px',
      borderRadius: '8px',
      border: '1px solid #ccc',
      textAlign: 'center',
    },
    phoneInput: {
      width: '100%',
      fontSize: '16px',
    },
  };


  const handleClose = () => {
    setShow(false);
  };
  const [copied, setcopied] = useState(false);
  const [web3copied, setweb3copied] = useState(false);
  

  useEffect(() => {
   
    get_users(page, search, selectUserType.value, selectIsSolana);
    getBonusPoint()
  }, []);
  const [bonusPoint, setBonusPoint] = useState({ totalPoints: 0, maximumIpBonusPoint: 0 });

  const getBonusPoint = async () => {
    try {
      const response = await apiService.getBonusPoint();
      if (response.status === 200) {
        setBonusPoint(response.data.data);
      }
    } catch (error) {
    }
  };

  const handleEditClick = (rowData) => {
    console.log("====", rowData.wallet_address)
    // setSelectedRow(rowData);
    setWallet(rowData.wallet_address)
    setError("");
    setShowEditModal(true);
  };
  const handleEditClickPhone = (rowData) => {
    console.log("====", rowData)
    // setSelectedRow(rowData);
    setUserId(rowData._id)
    // setError("");
    setShowPhoneEditModal
      (true);
  };

  const tooltiptoggle = (
    <Tooltip id="tooltip">
      <p className="m-0 p-0">Change Status</p>
    </Tooltip>
  );
  const setcopytext = () => {
    setTimeout(() => {
      setcopied(false);
    }, "1000");
  };
  const setweb3copytext = () => {
    setTimeout(() => {
      setweb3copied(false);
    }, "1000");
  };
  const copytooltip = (
    <Tooltip id="tooltip">{copied ? "Copied" : "Copy"}</Tooltip>
  );
  const web3copytooltip = (
    <Tooltip id="tooltip">{web3copied ? "Copied" : "Copy"}</Tooltip>
  );
  const tooltip = (
    <Tooltip id="tooltip">
      <p className="m-0 p-0">Edit Point</p>
    </Tooltip>
  );

  function handleChangeUserType(value) {
    setSelectUserType(value);
    setSearch("");
    setPage(0);
    get_users(0, '', value.value, selectIsSolana);

  }

  function handleChangeIsSolana(value) {
    setSelectIsSolana(value.value);
    setSearch("");
    setPage(0);
    get_users(0, '', selectUserType.value, value.value);

  }

  async function get_users(page, search, selectUserType, solanaTmp) {
    setLoader(true);
    try {

      const response = await apiService.get_users(page, search, selectUserType, solanaTmp);
      if (response?.status == 200) {
        let responseData = response.data.data.list;
        setUserData(responseData);
        setTotalItems(response?.data?.data.totalRecords);

        setLoader(false);
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        setLoader(false);

        swal({ icon: "error", text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear();
          window.location.href = "/";
          console.log("OK button clicked after error alert");
        });
      } else {
        setLoader(false);

        swal({
          icon: "error",
          text: error?.response?.data?.message
            ? error?.response?.data?.message
            : error?.message,
          button: "OK",
        }).then((value) => {
          console.log("OK button clicked after error alert");
        });
      }
    }
  }

  function handlePageChange(pageNumber) {
    console.log("??????page", pageNumber);
    if (page != pageNumber - 1) {
      setPage(pageNumber - 1);
      get_users(pageNumber - 1, search, selectUserType.value);
    }
  }

  function handleUpdateSearch(search) {
    setSearch(search);
    setPage(0);
  }

  function disableUser() {
    if (deactivatedReason !== "") {
      console.log("??????????????saveeeebutton click", deactivatedReason);
      setReasonError("");
      setShow(false);
    } else {
      setReasonError("Please enter the reason");
    }
  }


  const nftseedDatabase = async () => {
    setLoader(true);
    try {
      const response = await apiService.nftseedDatabase();
      if (response?.status == 200) {
        setLoader(false);
        swal("Success", "Data added successfully", "success")
        // console.log(response.data.data.downloadurl)
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        setLoader(false);

        swal({ icon: "error", text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear();
          window.location.href = "/";
          console.log("OK button clicked after error alert");
        });
      } else {
        setLoader(false);

        swal({
          icon: "error",
          text: error?.response?.data?.message
            ? error?.response?.data?.message
            : error?.message,
          button: "OK",
        }).then((value) => {
          console.log("OK button clicked after error alert");
        });
      }
    }
  };
  const formatAddress = (addr) => {
    return `${addr.substring(0, 4)}...${addr.substring(addr.length - 4)}`;
  };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span>Closed</span>;
    } else {
      return (
        <span>
          {days + "d"} {hours + "h"}:{minutes + "m"}:{seconds + "s"}
        </span>
      );
    }
  };
  function getTodayEndUTC() {
    const now = new Date();
    const todayEndUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 23, 59, 59, 999));
    return todayEndUTC;
  }
  const handleSaveChanges = async () => {
    if (!editedPoint) {
      setError("Points is required.");
      return;
    }

    if (isNaN(editedPoint) || Number(editedPoint) <= 0) {
      setError("Points must be greater than zero.");
      return;
    }
    setError("");
    setLoader(true);
    let params = {
      points: editedPoint,
      wallet_address: wallet_address
    }
    const response = await apiService.updateUserPoint(updateType, params);
    get_users(page, search, selectUserType.value, selectIsSolana);
    setEditedPoint("")
    setWallet("")
    setShowEditModal(false);
    setLoader(false);
    swal({
      text: `Points updated successfully.`,
      icon: "success",
    });
  };

  const handleSaveChangesPhone = async () => {
    console.log("====editedPhone====", editedPhone);

    if (!editedPhone) {
      setError("Phone is required.");
      return;
    }

    setError("");
    setLoader(true);

    try {
      const params = {
        phone: editedPhone,
        user_id: userId,
      };

      const response = await apiService.updateUserPhone(params);
      console.log("======response=====", response.status);

      if (response.status === 200) {
        swal({
          text: "Phone updated successfully.",
          icon: "success",
        });

        get_users(page, search, selectUserType.value, selectIsSolana);
        setEditedPhone("");
        setUserId("");
        setShowPhoneEditModal(false); // if you want to close modal on success
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || error?.message || "Failed to update phone.";

      swal({
        icon: "error",
        text: message,
        button: "OK",
      });
    } finally {
      setLoader(false); // ✅ Always stop the loader
    }
  };

  async function handleToggle(user) {
    swal({
      title: `Are you sure you want to ${user.isBlocked ? 'unblock' : 'block'} this user?`,
      text: `This action will ${user.isBlocked ? 'unblock' : 'block'} the user with wallet address: ${(user.wallet_address)}.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willToggle) => {
      if (willToggle) {
        const response = await apiService.userBlockUnblock({ userId: user._id, });
        if (response?.status == 200) {
          swal(`User has been ${user.isBlocked ? 'unblocked' : 'blocked'} successfully.`, {
            icon: "success",
          });
          get_users(page, search, selectUserType.value);
        }
      }
    });
  }


  const handleDownloadCSV = async () => {
    try {
      
      let token = localStorage.getItem("admin_token"); // or however you store it
      console.log("====token=====",token)
      token = token ? JSON.parse(token) : false;
      const res = await fetch(
        `${apiUrl}/admin/generateCSVUser?user_type=${selectUserType.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `${token}`,
          },
        }
      );
  
      if (!res.ok) {
        const errorText = await res.text();
        console.error("Download failed:", res.status, errorText);
        throw new Error("Failed to download CSV");
      }
  
      // ✅ convert response into a blob (this is critical for file download)
      const blob = await res.blob();
  
      // ✅ create a temporary download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "users.csv"; // filename
      document.body.appendChild(a);
      a.click();
  
      // ✅ cleanup
      a.remove();
      window.URL.revokeObjectURL(url);
  
      console.log("✅ CSV downloaded successfully");
    } catch (error) {
      console.error("❌ Error downloading CSV:", error);
    }
  };
  
  const handleDownloadBetCSV = async () => {
    try {
      
      let token = localStorage.getItem("admin_token"); // or however you store it
      console.log("====token=====",token)
      token = token ? JSON.parse(token) : false;
      const res = await fetch(
        `${apiUrl}/admin/generateCSVBet`,
        {
          method: "GET",
          headers: {
            Authorization: `${token}`,
          },
        }
      );
  
      if (!res.ok) {
        const errorText = await res.text();
        console.error("Download failed:", res.status, errorText);
        throw new Error("Failed to download CSV");
      }
  
      // ✅ convert response into a blob (this is critical for file download)
      const blob = await res.blob();
  
      // ✅ create a temporary download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "userBet.csv"; // filename
      document.body.appendChild(a);
      a.click();
  
      // ✅ cleanup
      a.remove();
      window.URL.revokeObjectURL(url);
  
      console.log("✅ CSV downloaded successfully");
    } catch (error) {
      console.error("❌ Error downloading CSV:", error);
    }
  };


  return (
    <>
      <div className="dashboard-main-area">
        {loader == true ? <ThreeDotSpinner /> : ""}

        <Container fluid>
          <div className="dashboard-area-heading management-heading">
            <Row className="row justify-content-center align-items-center mb-3">
              <Col md={12} lg={11}>
                <div className="heading-top-area">
                  <div className="d-flex ">
                    <h2 className="align-self-center m-0">Users</h2>
                  </div>
                  <div className="heading-top-area-right">


                    <div className={`bonus-points`}>
                      <p class="animate-charcter"><span>Bonus points:</span> {Number(bonusPoint.maximumIpBonusPoint) - Number(bonusPoint.totalPoints)}</p>
                      <div className="bonus-countdown">
                        <Countdown date={moment(getTodayEndUTC().getTime()).format("YYYY-MM-DD HH:mm:ss")} renderer={renderer} />
                      </div>
                    </div>

                    <div className="search-area user-search-area">
                      <label>Search</label>
                      <form
                        onSubmit={(event) => {
                          event.preventDefault();
                        }}
                      >
                        <input
                          type="text"
                          className="form-control inner-input"
                          onChange={(e) => handleUpdateSearch(e.target.value)}
                          onKeyDown={(e) => {
                            if (!e.target.value && e.code === "Space") {
                              e.preventDefault();
                            }
                            if (e.key === "Enter") {
                              get_users(page, search, selectUserType.value);
                            }
                          }}
                        />
                        <i
                          className="fa fa-search"
                          aria-hidden="true"
                          onClick={() => get_users(page, search, selectUserType.value)}
                        ></i>
                        <i
                          className="fa fa-close d-none"
                          aria-hidden="true"
                        ></i>
                      </form>
                    </div>
                    <div className="filter-top-area me-2">
                      <Form.Group
                        className=""
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label className="mb-0">User Type:</Form.Label>
                        <Select
                          options={userTypeOptions}
                          defaultValue={selectUserType}
                          Value={selectUserType}
                          onChange={(e) => handleChangeUserType(e)}
                        />
                      </Form.Group>
                    </div>
                    <div className="filter-top-area me-2">
                      <Form.Group
                        className=""
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label className="mb-0">solana:</Form.Label>
                        <Select
                          options={solanaOptions}
                          defaultValue={selectIsSolana}
                          Value={selectIsSolana}
                          onChange={(e) => handleChangeIsSolana(e)}
                        />
                      </Form.Group>
                    </div>
                    <button className="download-csv" onClick={handleDownloadCSV}>
                      <i className="fa fa-download" aria-hidden="true"></i> Download User CSV
                    </button>

                    {/* <a className="download-csv" download href={`${apiUrl}/admin/generateCSVUser?user_type=${selectUserType.value}`}><i className="fa fa-download" aria-hidden="true"></i> Download User CSV</a> */}

                 
                    <button className="download-csv" onClick={handleDownloadBetCSV}>
                      <i className="fa fa-download" aria-hidden="true"></i> Export CSV
                    </button>
      

                    <Button type="buttton" variant="unset" onClick={nftseedDatabase}>Fetch Referral Data</Button>

                    <AirdropNotifyRowAction user={""} mode={"All"} />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="pb-4 justify-content-center">
              <Col md={12} lg={11}>
                <div className="audit-request-box">
                  <Table responsive="sm" className="UserListTable">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Wallet Address</th>
                        <th>Web3 Wallet Address</th>
                        <th>Wallet Type</th>
                        <th>Email</th>
                        <th>Total Prediction</th>
                        {/* <th className="email-section">Amount Spent</th> */}
                        <th>Reward Amount</th>
                        <th>Platform</th>
                        <th>Twitter/X handle </th>
                        <th>solana address</th>
                        <th>Phone Number</th>
                        <th>Available Points</th>
                       
                        <th>Blocked</th>
                        <th>Signup Ip</th>
                        <th>Age Range</th>
                        <th>Weekly Spending</th>
                        <th>Created At</th>
                        <th>Profile Q&A</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userData && userData?.length > 0 ? (
                        userData.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td
                                onClick={setcopytext}
                                style={{ cursor: "pointer" }}
                              >
                                <a
                                  href={
                                    "/transaction?wallet_address=" +
                                    data?.wallet_address
                                  }
                                >
                                  {data?.wallet_address ? (
                                    <>{formatAddress(data?.wallet_address)}</>
                                  ) : (
                                    <>-</>
                                  )}

                                </a>{" "}
                                <OverlayTrigger
                                  placement="top"
                                  overlay={copytooltip}
                                >
                                  <CopyToClipboard
                                    text={data?.wallet_address}
                                    onCopy={() => setcopied(true)}
                                  >
                                    <i
                                      class="fa fa-clipboard"
                                      aria-hidden="true"
                                    ></i>
                                  </CopyToClipboard>
                                </OverlayTrigger>
                              </td>
                              <td
                                onClick={setweb3copytext}
                                style={{ cursor: "pointer" }}
                              >
                                <a
                                  href={
                                    "/transaction?wallet_address=" +
                                    data?.wallet_address
                                  }
                                >
                                  {data?.web3_wallet_address ? (
                                    <>{formatAddress(data?.web3_wallet_address)}</>
                                  ) : (
                                    <>-</>
                                  )}

                                </a>{" "}
                                <OverlayTrigger
                                  placement="top"
                                  overlay={web3copytooltip}
                                >
                                  <CopyToClipboard
                                    text={data?.web3_wallet_address}
                                    onCopy={() => setweb3copied(true)}
                                  >
                                    <i
                                      class="fa fa-clipboard"
                                      aria-hidden="true"
                                    ></i>
                                  </CopyToClipboard>
                                </OverlayTrigger>
                              </td>
                              <td>{data?.user_type}</td>
                              <td>{data?.phone_or_email}</td>
                              <td>{data?.leaderboardData ? data?.leaderboardData?.predictionCount : 0}</td>
                              {/* <td>{formatBalance(data?.totalAmount)}</td> */}
                              <td>{formatBalance(data?.totalRewardAmount)}</td>
                              <td>{data?.platform}</td>
                              <td>{data?.twitter_handle ? data?.twitter_handle : "-"}</td>

                              <td
                                onClick={setcopytext}
                                style={{ cursor: "pointer" }}
                              >

                                {data?.custodial_solana_address ? (
                                  <>{formatAddress(data?.custodial_solana_address)}</>
                                ) : (
                                  <>-</>
                                )}

                                {data?.custodial_solana_address &&
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={copytooltip}
                                  >
                                    <CopyToClipboard
                                      text={data?.custodial_solana_address}
                                      onCopy={() => setcopied(true)}
                                    >
                                      <i
                                        class="fa fa-clipboard"
                                        aria-hidden="true"
                                      ></i>
                                    </CopyToClipboard>
                                  </OverlayTrigger>
                                }
                              </td>
                              <td>{data?.phone ? data?.phone : "N/A"}
                                {data?.phone ? <></> :
                                  <div className="view-eye-area">
                                    <div
                                      className="d-flex align-items-center"
                                      onClick={() => handleEditClickPhone(data)}

                                    >
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={tooltip}
                                      >
                                        <div className="edit-pencil">
                                          <i className="fa fa-pencil" style={{ cursor: "pointer" }}></i>
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                  </div>
                                }

                              </td>
                              <td className="edit-points">{data?.leaderboardData ? parseInt(data?.leaderboardData?.points) - parseInt(data?.leaderboardData?.redemmed_points) : 0}

                                <div className="view-eye-area">
                                  <div
                                    className="d-flex align-items-center"
                                    onClick={() => handleEditClick(data)}

                                  >
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={tooltip}
                                    >
                                      <div className="edit-pencil">
                                        <i className="fa fa-pencil" style={{ cursor: "pointer" }}></i>
                                      </div>
                                    </OverlayTrigger>
                                  </div>
                                </div>
                              </td>

                              <td>
                                <Form.Check
                                  type="switch"
                                  id="custom-switch"
                                  checked={data?.isBlocked}
                                  onChange={() => handleToggle(data)}
                                />                                
                              </td>
                              <td>{data?.signup_ip}</td>
                              <td>{data?.age_range?data?.age_range:"N/A"}</td>
                              <td>{data?.weekly_discretionary_spend?data?.weekly_discretionary_spend:"N/A"}</td>
                              
                              <td>
                                {moment(data?.createdAt).format(dateFormate)}
                              </td>
                              <td>
                                {data?.profileQuestionAnswers?.length > 0 ? (
                                  <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0"
                                    onClick={() => {
                                      setSelectedProfileAnswers(data.profileQuestionAnswers);
                                      setShowProfileAnswersModal(true);
                                    }}
                                  >
                                    View ({data.profileQuestionAnswers.length})
                                  </Button>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                <AirdropNotifyRowAction user={data} mode={"one"} />
                              </td>

                            </tr>
                          );
                        })
                      ) : (
                        <tr className="no-dat-found-box">
                          <td colSpan={18}>
                            <img
                              src={
                                require("../../assets/images/no-data.svg")
                                  .default
                              }
                              alt="da"
                            />
                            <h3 className="text-center text-light">
                              No data found
                            </h3>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {userData && userData.length > 0 ? (
                    <Pagination
                      activePage={page + 1}
                      itemsCountPerPage={limit}
                      totalItemsCount={totalItems}
                      pageRangeDisplayed={5}
                      onChange={(e) => handlePageChange(e)}
                      prevPageText={"Prev"}
                      nextPageText={"Next"}
                    />
                  ) : null}
                </div>
              </Col>
            </Row>
          </div>
        </Container>

        <Modal show={show} onHide={handleClose} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Call Key Points</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {calldata &&
              calldata.map((data, index) => {
                if (data.summary) {
                  const format1 = "DD-MM-YYYY HH:mm:ss";
                  var duration = moment.duration(
                    parseInt(data.call_duration),
                    "seconds"
                  );
                  console.log("====duration==", duration);
                  var formatted = duration.format("hh:mm:ss");
                  var date1 = new Date(data.call_time);
                  var dateTime1 = moment(date1).format(format1);
                  return (
                    <div className="keynote">
                      <p>
                        {" "}
                        Date&Time: <b>{dateTime1}</b>
                      </p>
                      <p className="">
                        {" "}
                        Duration: <b>{formatted}</b>
                      </p>
                      <p
                        dangerouslySetInnerHTML={{ __html: data.summary }}
                        className="call-key-text"
                      ></p>
                    </div>
                  );
                }
              })}
          </Modal.Body>
          <Modal.Footer className="pt-3">
            <Button
              variant="secondary"
              onClick={handleClose}
              className="close-btn"
            >
              Close
            </Button>
            <Button variant="primary" onClick={disableUser}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>


        {/* Edit Modal */}


        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit User Point</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group
              className=""
              controlId="exampleForm.ControlInput1"
            >
              <Form.Label className="mb-0">Update Type:</Form.Label>
              <Select
                options={optionsUpdateType}
                placeholder="Select Type"
                onChange={(e) => setupdateType(e.value)}
              />
            </Form.Group>

            <Form.Group controlId="editGasFee">
              <Form.Label>Points</Form.Label>
              <Form.Control maxLength={8}
                type="text"
                value={editedPoint}
                onChange={(e) => setEditedPoint(e.target.value)}
                placeholder="Enter Points"
              />
              {error && <span className="text-danger">{error}</span>}
            </Form.Group>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSaveChanges}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>



        <Modal show={showPhoneEditModal} onHide={() => setShowPhoneEditModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Edit Phone </Modal.Title>
          </Modal.Header>
          <Modal.Body>


            <Form.Group controlId="editGasFee">
              {/* <Form.Label>Phone</Form.Label> */}
              <PhoneInput
                country={'in'}
                value={editedPhone}
                onChange={(value, country, e, formattedValue) => {
                  const e164 = value ? `+${value}` : ''; setEditedPhone(e164);
                }}
                inputStyle={styles.phoneInput}
                containerStyle={{ width: '100%' }}
                placeholder='Enter your number'
              // disabled={confirmationResult || sendOtpLoader}
              />
              {/* <Form.Control maxLength={8}
                type="text"
                value={editedPoint}
                onChange={(e) => setEditedPhone(e.target.value)}
                placeholder="Enter Points"
              /> */}
              {error && <span className="text-danger">{error}</span>}
            </Form.Group>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setShowPhoneEditModal(false);
              setEditedPhone(""); // Clear phone input when closing
              setError("");        // Optional: clear any error message too
            }}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSaveChangesPhone}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Profile Question Answers Modal */}
        <Modal show={showProfileAnswersModal} onHide={() => setShowProfileAnswersModal(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Profile Question Answers</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedProfileAnswers?.length > 0 ? (
              <div className="profile-question-answers-list">
                {selectedProfileAnswers.map((qa, idx) => (
                  <div key={qa.profileQuestionId || idx} className="mb-3 p-3 rounded" style={{ backgroundColor: "rgba(0,0,0,0.05)", border: "1px solid #eee" }}>
                    <p className="mb-1 small text-muted">Question</p>
                    <p className="mb-2">{qa.question || "-"}</p>
                    <p className="mb-1 small text-muted">Type: {qa.type || "-"}</p>
                    <p className="mb-1 small text-muted">Answer(s)</p>
                    <p className="mb-0">
                      {qa.selectedOptions && qa.selectedOptions.length > 0 ? qa.selectedOptions.join(", ") : "-"}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="mb-0">No profile question answers.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowProfileAnswersModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
